import { ChevronRight, MapPin, User2 } from "lucide-react";

const STATUS = {
  planned: { label: "Ej påbörjad", cls: "border-slate-200 bg-slate-100 text-slate-700" },
  in_progress: { label: "Pågår", cls: "border-blue-200 bg-blue-50 text-blue-800" },
  done: { label: "Klar", cls: "border-emerald-200 bg-emerald-50 text-emerald-800" },
  ready_to_invoice: { label: "Avslutad", cls: "border-amber-200 bg-amber-50 text-amber-900" },
  invoiced: { label: "Fakturerad", cls: "border-violet-200 bg-violet-50 text-violet-800" },
};

const TYPE = { field: "Utejobb", workshop: "Verkstad", installation: "nymontering", open: "Uthyrning" };
const TYPE_CLS = {
  field: "border-green-300 bg-green-50 text-green-800",
  workshop: "border-yellow-300 bg-yellow-50 text-yellow-800",
  open: "border-blue-300 bg-blue-50 text-blue-800",
  installation: "border-purple-300 bg-purple-50 text-purple-800",
};

const jobLabel = (j) => (j.job_type === "installation" ? `Maskinnr ${j.machine_no || "–"}` : j.title);

export const AgendaView = ({ days, todayKey, dayNames, onOpenJob }) => (
  <div className="space-y-3" data-testid="calendar-agenda">
    {days.map((d, i) => {
      const isToday = d.key === todayKey;
      return (
        <div
          key={d.key}
          data-testid={`agenda-day-${d.key}`}
          className={`overflow-hidden rounded-lg border bg-white ${
            isToday ? "border-blue-400 ring-1 ring-blue-200" : "border-slate-200"
          }`}
        >
          <div className={`flex items-center gap-2 px-3 py-2 ${isToday ? "bg-blue-50" : "bg-slate-50"}`}>
            <span className="text-sm font-bold uppercase tracking-[0.05em] text-slate-700">
              {dayNames[i % 7]} {d.date.getDate()}/{d.date.getMonth() + 1}
            </span>
            {d.holiday && (
              <span title={d.holiday} data-testid={`agenda-holiday-${d.key}`} className="text-xs font-semibold text-red-600">
                ★ {d.holiday}
              </span>
            )}
            {isToday && (
              <span className="rounded-full bg-blue-600 px-2 py-0.5 text-[11px] font-semibold text-white">
                Idag
              </span>
            )}
            <span className="ml-auto text-xs font-medium text-slate-500" data-testid={`agenda-count-${d.key}`}>
              {d.jobs.length === 0 ? "Inga jobb" : `${d.jobs.length} jobb`}
            </span>
          </div>

          {d.absences.length > 0 && (
            <div className="border-b border-orange-100 bg-orange-50 px-3 py-1.5 text-xs font-semibold text-orange-800">
              {d.absences.length} frånvaro denna dag
            </div>
          )}

          {d.jobs.length > 0 && (
            <ul className="divide-y divide-slate-100">
              {d.jobs.map((j) => {
                const st = STATUS[j.workflow_status] || STATUS[j.status] || STATUS.planned;
                return (
                  <li key={j.id}>
                    <button
                      data-testid={`agenda-job-${d.key}-${j.id}`}
                      onClick={() => onOpenJob(j)}
                      className="flex w-full items-center gap-3 px-3 py-3 text-left transition-colors duration-200 hover:bg-blue-50/50"
                    >
                      <span className="w-14 shrink-0 font-heading text-base font-bold tabular-nums text-slate-900">
                        {j.start?.slice(11, 16) || "–"}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-base font-semibold text-slate-900">
                          {jobLabel(j)}
                        </span>
                        <span className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-sm text-slate-600">
                          {j.customer_name && (
                            <span className="flex items-center gap-1">
                              <User2 className="h-3.5 w-3.5 text-slate-400" /> {j.customer_name}
                            </span>
                          )}
                          {j.address && (
                            <span className="flex items-center gap-1">
                              <MapPin className="h-3.5 w-3.5 text-slate-400" /> {j.address}
                            </span>
                          )}
                        </span>
                        <span className="mt-1 flex flex-wrap items-center gap-1.5">
                          <span className={`rounded border px-1.5 py-0.5 text-[11px] font-semibold ${st.cls}`}>
                            {st.label}
                          </span>
                          <span className={`rounded border px-1.5 py-0.5 text-[11px] font-medium ${TYPE_CLS[j.job_type] || TYPE_CLS.field}`}>
                            {TYPE[j.job_type] || TYPE.field}
                          </span>
                          {j.job_type === "installation" && j.title && (
                            <span className="truncate text-[11px] text-slate-500">{j.title}</span>
                          )}
                        </span>
                      </span>
                      <ChevronRight className="h-4 w-4 shrink-0 text-slate-400" />
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      );
    })}
  </div>
);

export default AgendaView;
